import { render } from "./bannerNoticeAdd.vue?vue&type=template&id=117ccdb9&scoped=true"
import script from "./bannerNoticeAdd.vue?vue&type=script&lang=js"
export * from "./bannerNoticeAdd.vue?vue&type=script&lang=js"

import "./bannerNoticeAdd.vue?vue&type=style&index=0&id=117ccdb9&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-117ccdb9"]])

export default __exports__